import React, { Fragment } from "react";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";

import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import Link from "@mui/material/Link";

import VlmDisplay from "./VlmDisplay";

import { stringIsMarkdownForHyperlink } from "../../../../Logic/stringIsMarkdownForHyperlink";
import { stringIsMarkdownForEmail } from "../../../../Logic/stringIsMarkdownForEmail";

import config from "../../../../config.json";

const { dataSettings, baseURLforScripts, baseURLforData } = config;
const { display } = dataSettings;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,

  overflow: "auto",
  height: "75%",
  width: "75%",
  display: "block",
};

function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

function AdditionalInfo({
  open,
  handleClose,
  columnsOnAdditionalInfo,
  colForTitleForAdditionalInfoPage,
  datum,
}) {
  // Helpers for rendering

  // Render the title
  const renderTitle = (title) => {
    return (
      <Fragment>
        Additional Details for <code>{title}</code>
      </Fragment>
    );
  };

  const renderLink = (stringIsHyperlink, display, i) => {
    const [full, title, url] = stringIsHyperlink;
    return (
      <TableRow
        key={i}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <b>{display}</b>
        </TableCell>

        <TableCell>
          {" "}
          <Link href={url} variant="body2" target="_blank" rel="noreferrer">
            {title}
          </Link>
        </TableCell>
      </TableRow>
    );
  };

  const renderEmail = (stringIsEmail, display, i) => {
    const [full, title, url] = stringIsEmail;
    return (
      <TableRow
        key={i}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <b>{display}</b>
        </TableCell>

        <TableCell>
          {title} (
          <Link href={`mailto:${url}`} variant="body2">
            {url}
          </Link>
          )
        </TableCell>
      </TableRow>
    );
  };

  // Render an individual row of the table
  const renderListItemRow = (datum, display, i) => {
    const stringIsEmail = stringIsMarkdownForEmail(datum);
    const stringIsHyperlink = stringIsMarkdownForHyperlink(datum);

    if (stringIsEmail) {
      return renderEmail(stringIsEmail, display, i);
    }

    if (stringIsHyperlink) {
      return renderLink(stringIsHyperlink, display, i);
    }
    return (
      <TableRow
        key={i}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <b>{display}</b>
        </TableCell>

        <TableCell>
          {" "}
          {isValidUrl(datum) ? (
            <a href={datum} target="_blank" rel="noopener noreferrer">
              {datum}
            </a>
          ) : (
            datum
          )}
        </TableCell>
      </TableRow>
    );
  };

  // Main rendering

  if (datum) {
    const { vlm_for_display } = datum;
    const { table_name } = datum;

    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {renderTitle(datum[colForTitleForAdditionalInfoPage])}
          </Typography>
          <Stack spacing={2}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                  {columnsOnAdditionalInfo.map((col, i) => {
                    if (datum[col] != null) {
                      return renderListItemRow(datum[col], display[col], i);
                    } else {
                      return null;
                    }
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {vlm_for_display ? (
              <VlmDisplay vlm_for_display={vlm_for_display} />
            ) : null}
          </Stack>
        </Box>
      </Modal>
    );
  } else {
    return null;
  }
}

export default AdditionalInfo;
